import Vue from "vue";
const state = {
  files: {}
};
const mutations = {
  TRACK_PROGRESS(state, { filename, progress, complete, url }) {
    Vue.set(state.files, filename, { filename, progress, complete, url });
  }
};
const actions = {
  trackProgress(context, { filename, progress, complete, url }) {
    context.commit("TRACK_PROGRESS", { filename, progress, complete, url });
  }
};
const getters = {
  getProgress: state => filename => {
    return state.files[filename] ? state.files[filename].progress : 0;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
